const SEARCH_FIELD = {
  PHYSICAL_BRANCH_ID: "physical_branch_id",
  BRANCH_ID: "branch_id",
  MONTH: "month",
  TO_DATE: "to_date",
  FROM_DATE: "from_date",
  ITEM_NO: "item_no",
  PAYMENT_METHOD_TYPE: "payment_method_type",
};

export { SEARCH_FIELD };
